import CircleIcon from '@mui/icons-material/Circle';
import { Typography } from "@mui/material";
import { ReactNode } from "react";
import { PopupMessage } from '../../../components/PopupMessage';
import { DisclaimerText } from "../TrainingHistoryModels";
import { bulletinIconStyle, contentStyle } from "./../styled";

const Content = ({ children }: { children: ReactNode }) => {
  return (
    <Typography sx={contentStyle}>
      <CircleIcon sx={bulletinIconStyle} />
      {children}
    </Typography>
  );
}

export const Disclaimer = ({ onClick }: { onClick: () => void }) => {
  return (
    <PopupMessage title='Status Code Descriptions' onClose={onClick}>
      {DisclaimerText.map(paragraph => (<Content key={paragraph}>{paragraph}</Content>))}
    </PopupMessage>
  );
}